import base64 from 'base-64';

const URL_PREFIX = window.location.origin;

export function getLink(jobId: number) {
    return `${URL_PREFIX}/gotandem/${base64.encode(jobId.toString())}`;
}
